import { render, staticRenderFns } from "./StoreLocatorConfigSearchRegions.vue?vue&type=template&id=5ed45ef0&scoped=true&"
import script from "./StoreLocatorConfigSearchRegions.vue?vue&type=script&lang=js&"
export * from "./StoreLocatorConfigSearchRegions.vue?vue&type=script&lang=js&"
import style0 from "./StoreLocatorConfigSearchRegions.vue?vue&type=style&index=0&id=5ed45ef0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed45ef0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
